// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__32spS","label":"SetPasswdForm_label__10ynS"};